import React, { useMemo } from 'react';

import { useIntl } from 'react-intl-next';
import { Link, usePathParam } from 'react-resource-router';

import Avatar from '@atlaskit/avatar';
import AtlaskitBreadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { Box, xcss } from '@atlaskit/primitives';
import { useResponderNames } from '@atlassian/eoc-responder-names';

import messages from './messages';

const AvatarContainerStyles = xcss({
	paddingRight: 'space.050',
});

export const Breadcrumbs = () => {
	const [teamId] = usePathParam('teamId');
	const requestedResponders = useMemo(() => {
		if (teamId) {
			return [{ id: teamId, type: 'team' } as const];
		}
		return [];
	}, [teamId]);
	const [team] = useResponderNames(requestedResponders);
	const { formatMessage } = useIntl();

	return teamId ? (
		<AtlaskitBreadcrumbs>
			<BreadcrumbsItem
				text={formatMessage(messages.teams)}
				href="/jira/people/search"
				component={Link}
			/>
			{team && 'name' in team && (
				<BreadcrumbsItem
					text={team.name}
					href={`/jira/ops/teams/${teamId}/on-call`}
					component={Link}
					iconBefore={
						<Box xcss={AvatarContainerStyles}>
							<Avatar
								appearance="square"
								borderColor="transparent"
								size="xsmall"
								src={team.avatarUrl}
							/>
						</Box>
					}
				/>
			)}
			<BreadcrumbsItem text={formatMessage(messages.heartbeatsTitle)} key="Parent page" />
		</AtlaskitBreadcrumbs>
	) : (
		<></>
	);
};
